// Brand logo component — uses the real JDSN Lawn Care logo
export default function Logo({ size = 40, className = "", withRing = false }) {
  const inner = (
    <img
      src="/icons/jdsn-logo.png"
      alt="JDSN Lawn Care"
      width={size}
      height={size}
      className={`block object-contain select-none ${className}`}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
  if (!withRing) return inner;
  return (
    <div
      className="rounded-full bg-white border border-emerald-200 shadow-sm flex items-center justify-center"
      style={{ width: size, height: size, padding: Math.max(2, Math.round(size * 0.06)) }}
    >
      <img
        src="/icons/jdsn-logo.png"
        alt="JDSN Lawn Care"
        className="block object-contain select-none"
        style={{ width: "100%", height: "100%" }}
        draggable={false}
      />
    </div>
  );
}
